import { omit } from "lodash";
import { emptySplitApi } from "./empty-split-api";
import {
  ManagedCarePlan,
  ManagedCarePlanFilter,
  ManagedCarePlanInput,
  ManagedCarePlanResponse,
} from "./types/managed-care-plans.type";
import { formatValidQueryParamUrl } from "../utils/common";

export const managedCarePlansApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getManagedCarePlans: builder.query<
      ManagedCarePlanResponse,
      ManagedCarePlanFilter | void
    >({
      query: (filter) => ({
        url: `/managed-care-plans/?${formatValidQueryParamUrl({
          is_active: filter?.is_active,
        })}`,
        params: {
          limit: 300,
        },
      }),
      providesTags: ["ManagedCarePlans"],
    }),
    getManagedCarePlan: builder.query<ManagedCarePlan, number>({
      query: (managedCarePlanId) => `/managed-care-plans/${managedCarePlanId}/`,
      providesTags: ["ManagedCarePlans"],
    }),
    addManagedCarePlan: builder.mutation<ManagedCarePlan, ManagedCarePlanInput>(
      {
        query: (managedCarePlanData) => ({
          url: "/managed-care-plans/",
          method: "POST",
          body: managedCarePlanData,
        }),
        invalidatesTags: ["ManagedCarePlans"],
      }
    ),
    editManagedCarePlan: builder.mutation<
      ManagedCarePlan,
      ManagedCarePlanInput
    >({
      query: (managedCarePlanData) => ({
        url: `/managed-care-plans/${managedCarePlanData.id}/`,
        method: "PATCH",
        body: omit(managedCarePlanData, "id"),
      }),
      invalidatesTags: ["ManagedCarePlans"],
    }),
  }),
});

export const {
  useGetManagedCarePlansQuery,
  useGetManagedCarePlanQuery,
  useAddManagedCarePlanMutation,
  useEditManagedCarePlanMutation,
} = managedCarePlansApi;
